// extracted by mini-css-extract-plugin
export default {"subsystemTab":"Subsystems_subsystemTab__BH5jk","subsystemTabButton":"Subsystems_subsystemTabButton__cR7Fy"};